import React from "react";
import './channelMember.sass';
import UserInfo from "../../components/UserInfo";
import api from "../../utils/api";
import { Popconfirm, Input, Button, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ChangeChannels from "../userList/com/changeChannels";
import qs from "../../utils/qs";

export default class ChannelMembers extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            dataSource: [],
            show_changeChannels: {
                show: false
            }
        }
    }

    componentDidMount() {

        this.getMembers();
    }



    getMembers = async () => {
        let param = {
            channel_id: qs.hrefParam('id')
        }

        let res = await api('get-members', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }

        console.log(res);

    }

    openChangeChannel = (ctx) => {//换组

        this.setState({
            show_changeChannels: {
                show: true,
                param: ctx
            }
        })

    }

    render() {


        let { dataSource, show_changeChannels } = this.state;

        const columns = [
            {
                title: '昵称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '手机号',
                dataIndex: 'desc',
                key: 'desc',
            },
            {
                title: '开团数',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '累计销售额',
                dataIndex: 'desc',
                key: 'desc',
            },
            {
                title: '团员数',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '进行中的团',
                dataIndex: 'desc',
                key: 'desc',
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (
                        <div className='flex'>

                            <p onClick={() => { this.openChangeChannel(ctx) }} className='pointer themeColor mgr10'>换组</p>

                            <Popconfirm
                                title='确认删除？'
                                okText='确认'
                                cancelText='取消'
                                onConfirm={() => {

                                    this.delChannel(ctx)

                                }}
                            >
                                <p className='warn pointer'>删除</p>
                            </Popconfirm>


                        </div>
                    )
                }
            },
        ];
        return (
            <div className='channelMembers'>
                <UserInfo />
                <div className='record'>

                    <div className='change_fans flex search'>
                        <div className='flex'>
                            <div className='flex line alignCenter'>
                                搜索昵称：
                                <Input placeholder='搜索昵称：' />
                            </div>


                            <div>
                                <Button icon={<SearchOutlined />}>搜索</Button>

                                <Button>重置</Button>
                            </div>

                        </div>

                        {/* <Button onClick={() => { this.setState({ createChannelShow: true }) }} icon={<PlusSquareOutlined />} className='createChannelBtn'>新建渠道</Button> */}


                    </div>

                    <div className='change_fans'>
                        <Table dataSource={dataSource} columns={columns} />
                    </div>
                </div>
                {
                    show_changeChannels.show ? (<ChangeChannels colsePop={(e) => { show_changeChannels.show = e; this.setState({ show_changeChannels }) }} />) : null
                }

            </div>
        )
    }

}